import { render, staticRenderFns } from "./SendingNotifications.vue?vue&type=template&id=6f177023"
import script from "./SendingNotifications.vue?vue&type=script&lang=js"
export * from "./SendingNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports